import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


import { CustomSQLQuery } from '../models/sql-query';
import { QueryType } from '../models/query-type';
import { protectedResources } from '../auth-config';
import { ToastService } from './toast.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CustomSQLQueryService {
  private baseUrl: string = protectedResources.LOSTalkerAPI.endpoint;
  private actionUrl = '';
  private Url = '';
  private headers = new HttpHeaders();

  private errorHandler(error: HttpErrorResponse, ts: ToastService): Observable<any> {
    ts.toastCreate('An HTTP transport error occured: ' + error.url + ' ' + error.status, 'Warning', {
      keepAfterRouteChange: true,
    });

    if (environment.enableDebuggingTools) {
      console.error('An HTTP transport error occured: ' + error.error);
    }

    return throwError(() => error);
  }

  constructor(private http: HttpClient, private toastService: ToastService) { }

  //--------------------------- CustomSQLQueries ------------------------------------------//

  getAllCustomQueries(): Observable<CustomSQLQuery[]> {
    this.actionUrl = 'CustomSQLQueries';
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .get<CustomSQLQuery[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getAllCustomQueriesByIntegration(id: string): Observable<CustomSQLQuery[]> {
    this.actionUrl = 'CustomSQLQueries/';
    this.Url = this.baseUrl.concat(this.actionUrl, id);

    return this.http
      .get<CustomSQLQuery[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  getCustomQueryById(id: string): Observable<CustomSQLQuery> {
    this.actionUrl = 'CustomSQLQuery/';
    this.Url = this.baseUrl.concat(this.actionUrl, id);

    return this.http
      .get<CustomSQLQuery[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  addCustomQuery(query: CustomSQLQuery): Observable<any> {
    this.actionUrl = 'CustomSQLQuery';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .post(this.Url, query, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  updateCustomQuery(query: CustomSQLQuery): Observable<any> {
    this.actionUrl = 'CustomSQLQuery';
    this.Url = this.baseUrl.concat(this.actionUrl);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .put(this.Url, query, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  deleteCustomQuery(query: CustomSQLQuery): Observable<any> {
    this.actionUrl = 'CustomSQLQuery/';
    this.Url = this.baseUrl.concat(this.actionUrl, query.customSQLQueryId);
    this.headers.append('Content-Type', 'application/json');

    return this.http
      .delete(this.Url, { headers: this.headers })
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }

  //--------------------------- QueryTypes ------------------------------------------//

  getAllQueryTypes(): Observable<QueryType[]> {
    this.actionUrl = 'QueryTypes';
    this.Url = this.baseUrl.concat(this.actionUrl);

    return this.http
      .get<QueryType[]>(this.Url)
      .pipe(catchError(err => this.errorHandler(err, this.toastService)));
  }
}
